import { api } from '@services';
import {
  FieldTypeOptions,
  ISelectableValuesApiModel,
} from '@models/CustomField.model';
import { Result } from '@utils/index';
import {
  UpdateContentError,
  toUniqueFieldsErr,
} from '../updateCustomFieldContent/updateCustomFieldContent';

interface IPatchField {
  name?: string;
  type?: FieldTypeOptions;
  isUnique?: boolean;
  isSearchable?: boolean;
  defaultValue?: string;
  description?: string;
  showOnOnboard?: boolean;
  content?: string;
  equipmentId?: string;
  selectValues?: ISelectableValuesApiModel[];
}
interface IPatchRequest {
  customFieldId: string | undefined;
  data: IPatchField;
}
const updateCustomField = async ({
  customFieldId,
  data,
}: IPatchRequest): Promise<void> => {
  const axiosResponse = api.patch(`/customFields/${customFieldId}`, data);

  const result = await Result.asyncCatch<UpdateContentError>(axiosResponse);

  const result_map = Result.mapErr(result, toUniqueFieldsErr);
  if (!result_map.is_ok) {
    throw result_map.error;
  }
};

export { updateCustomField };
